import type { ReactElement, ReactNode } from "react";
import { createContext, createElement, useContext } from "react";
import type { VendorSession } from "~/models/VendorSession";

const VendorSessionContext = createContext<VendorSession | null>(null);

type ProviderProps = {
	children: ReactNode;
	session: VendorSession;
};

export function VendorSessionProvider({
	session,
	children
}: ProviderProps): ReactElement {
	return createElement(
		VendorSessionContext.Provider,
		{ value: session },
		children
	);
}

export const useVendorSessionContext = (): VendorSession =>
	useContext(VendorSessionContext)!;
